import {EventLocations} from "@/enums/EventLocations";
import {FacilitySettingsModel} from "@/models/FacilitySettings";

export const EventLocationsMixin = {
    data() {
        return {
            newWingName: '',
            newLocationName: '',
            selectedGroups: {},
            isSelectedAllWings: false,
            selectedWingsIds: [],
            isShowAllWings: false,
            limitSelectedItems: 3
        }
    },
    created() {
        this.$store.dispatch("getEventLocations");
        this.$store.dispatch("getCareLevels");
        this.$store.dispatch("getCareAPIKey", this.currentFacility);
    },
    computed: {
        currentFacility(): string {
            return this.$store.state.authModule.currentFacility;
        },
        eventLocationsEnum() {
            return EventLocations;
        },
        eventLocations() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type !== EventLocations.Wing);
        },
        wings() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Wing);
        },
        wingsIds() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Wing).map(x => x.id);
        },
        rooms() {
            return [...[{ name: this.$t('GeneralTranslations.All'), value: "All", type: EventLocations.Room || EventLocations.Location}], ...this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Room || x.type === EventLocations.Location)];
        },
        residentWings() {
            return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Wing);
        },
        newRoomName() {
            return (this.$refs.rooms as any).lazySearch ?? "";
        },
        isDisable() {
            return !String(this.newLocationName).trim().length;
        },
        isDisableWing() {
            return !String(this.newWingName).trim().length;
        },
        isDisableRoom() {
            return !String(this.newRoomName).trim().length;
        },
        careLevels() {
            return this.$store.state.careLevelsModule.careLevels;
        },
        wingsLevelOfCare() {
            const arr: any[] = [];

            if(this.careLevels.length) {
                this.careLevels
                  .sort((a, b) => a.name.localeCompare(b.name, 'en-US'))
                  .forEach((level) => {
                      if(!arr.find(x => x.levelId === level.id)) {
                          arr.push({
                              levelId: level.id,
                              name: level.name,
                              group: true
                          });

                          if(level.wingsIds.length) {
                              level.wingsIds.forEach((wingId) => {
                                  const wing = this.wings.find(x => x.id === wingId);
                                  if(wing) {
                                      arr.push({
                                          id: wingId,
                                          name: wing?.name,
                                          levelId: level.id,
                                      })
                                  }
                              })
                          }
                      }
                  });

                arr.push({
                    levelId: 'All',
                    name: this.$t("NewCalendarItem.OtherWings"),
                    group: true
                })


                this.wings.forEach((wing) => {
                    if(!arr.find(x => x.id === wing.id)) {
                        arr.push({
                            id: wing.id,
                            name: wing?.name,
                            levelId: 'All',
                        })
                    }
                });
            } else {
                this.wings.forEach((wing) => {
                    if(!arr.find(x => x.id === wing.id)) {
                        arr.push({
                            id: wing.id,
                            name: wing?.name,
                            levelId: 'All',
                        })
                    }
                });
            }

            return arr;
        },
        isStaffCanCreateWings() {
            const facility: FacilitySettingsModel = this.$store.state.facilityModule.selectedFacility;

            return facility.isCanCreateWings === true;
        },
        isFacilityHasCareAPI() {
          return this.$store.state.facilityModule.isFacilityHasCareAPI;
        },
    },
    methods: {
        addNewLocation() {
            const form = {
                name: this.newLocationName,
                type: EventLocations.Location,
                facilityId: this.currentFacility
            };

            this.$store.dispatch("addEventLocation", form)
                .then(() => {
                    this.$toast.open({
                        message: this.$t('ViewCalendarItem.LocationSuccessfullyAddedMessage'),
                        type: "success"
                    });
                }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            });
        },
        addNewWing() {
            const form = {
                name: this.newWingName,
                type: EventLocations.Wing,
                facilityId: this.currentFacility
            };

            this.$store.dispatch("addEventLocation", form)
              .then(() => {
                  this.$toast.open({
                      message: this.$t('ViewCalendarItem.WingSuccessfullyAddedMessage'),
                      type: "success"
                  });
              }).catch((error) => {
                this.$toast.open({
                    message: `${error.message}`,
                    type: "error"
                });
            });
        },
        handleChange(item) {
            const group = this.wingsLevelOfCare.filter(x => x.levelId === item.levelId && !x.group);

            if (this.isGroupSelected(item) && !this.selectedGroups[item.levelId]) {
                const filteredGroup = this.checkDuplicationsWing(group);
                this.selectedWingsIds = this.selectedWingsIds.filter(x => !filteredGroup.map(x => x.id).includes(x));
            } else {
                this.selectedWingsIds = [...new Set([...this.selectedWingsIds, ...group.map(x => x.id)])];
            }
        },
        handleChangeWing(item) {
            if(this.isGroupSelected(item)) {
                this.selectedGroups[item.levelId] = true;
            } else {
                this.selectedGroups[item.levelId] = false;
            }

            this.$forceUpdate();
        },
        checkDuplicationsWing(group) {
            let items = group;

            const idCounts = new Map();
            this.wingsLevelOfCare.forEach(obj => {
                idCounts.set(obj.id, (idCounts.get(obj.id) || 0) + 1);
            });

            const levelsDuplicatedWings = new Set();
            group.forEach(uniqueObj => {
                if (idCounts.get(uniqueObj.id) > 1) {
                    this.wingsLevelOfCare
                      .filter(obj => obj.id === uniqueObj.id)
                      .forEach(x => levelsDuplicatedWings.add(x.levelId));
                }
            });

            const allDisabled = [...levelsDuplicatedWings].every((id: string) => this.selectedGroups[id] === false);

            if (!allDisabled) {
                items = group.filter(uniqueObj => idCounts.get(uniqueObj.id) === 1);
            }

            return items;
        },
        toggleAllWings() {
            if (this.isSelectedAllWings) {
                const groups = this.wingsLevelOfCare.filter(x => x.group);
                const wings = this.wingsLevelOfCare.filter(x => !x.group);

                this.selectedWingsIds = [...new Set([...this.selectedWingsIds, ...wings.map(x => x.id)])];
                groups.forEach(group => this.selectedGroups[group.levelId] = true);
            } else {
                this.selectedWingsIds = [];
                this.selectedGroups = {};
            }
        },
        isGroupSelected(item) {
            const groupIds = this.wingsLevelOfCare
              .filter(x => x.levelId === item.levelId && !x.group)
              .map(x => x.id);

            return groupIds.every(id => this.selectedWingsIds.includes(id));
        },
        openAllWings() {
            this.isShowAllWings = !this.isShowAllWings;
        },
    },
    watch: {
        selectedWingsIds(newValue) {
            const wings = this.wings.filter(x => !x.group);

            if(newValue.length === wings.length && wings.length) {
                this.isSelectedAllWings = true;
            } else {
                this.isSelectedAllWings = false;
            }

            if(newValue.length < this.selectedWingsIds.length) {
                this.wingsIds = newValue.map(x => x.id);

                newValue.forEach(item => {
                    this.selectedGroups[item.levelId] = this.isGroupSelected(item);
                })
            }
        }
    }
}